import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';

import AppHeader from "../appHeader/AppHeader";
import Spinner from '../spinner/Spinner';

const Page404 = lazy(()=>import('../pages/404'));
const MainPage = lazy(()=>import('../pages/MainPage'));
const ComicsPage = lazy(()=>import('../pages/ComicsPage'));
const SingleElementPage = lazy(()=>import('../pages/SingleElementPage'));

const App= () => {

        return (
                <Router>
                        <div className="app">
                                <AppHeader/>
                                <main>                                
                                        <Suspense fallback={<Spinner/>}>    {/* оборачиваем в реакт компонент ленивую загрузку  */}
                                                <Routes>
                                                        <Route path="/" element = {<MainPage/>}/>
                                                        <Route path="/comics" element = {<ComicsPage/>}/>
                                                        <Route path="/comics/:elementId" element = {<SingleElementPage/>}/>
                                                        <Route path="/character/:elementId" element = {<SingleElementPage/>}/>
                                                        <Route path="*" element = {<Page404/>}/>
                                                </Routes>                    
                                        </Suspense>
                                </main>
                        </div>
                </Router>
        )       
}

export default App;

//Загрузка с анимацией
// import { lazy, Suspense } from 'react';
// import { BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
// import { TransitionGroup, CSSTransition, SwitchTransition } from 'react-transition-group';

// import AppHeader from "../appHeader/AppHeader";
// import Spinner from '../spinner/Spinner';

// import './app.scss'

// import {MainPage, ComicsPage, SingleComicPage, Page404} from '../pages';


// const App= () => {

//         return (
//                 <Router>
//                         <div className="app">
//                                 <AppHeader/>
//                                 <main>                                
//                                        <Content/>
//                                 </main>
//                         </div>
//                 </Router>
//         )       
// }

// const Content = () => {
//         const location = useLocation();
//         return(
//                 <SwitchTransition>
//                         <CSSTransition
//                                 key={location.key}
//                                 classNames='fade'
//                                 timeout={300}
//                                 unmountOnExit
//                                 mountOnEnter
//                         >
//                                 <Routes>
//                                         <Route path="/" element = {<MainPage/>}/>
//                                         <Route path="/comics" element = {<ComicsPage/>}/>
//                                         <Route path="/comics/:comicId" element = {<SingleComicPage/>}/>
//                                         <Route path="*" element = {<Page404/>}/>
//                                 </Routes>
//                         </CSSTransition>
//                 </SwitchTransition>
//         )
// }


// export default App;